module.exports = __webpack_public_path__ + "img/error.67373f13.svg";